import { IFtthOffer } from "@nju/data-access-portal-offers";
import { IFtthOrchestrator } from "@nju/data-access-portal-orchestrator";
import { useDecodedToken } from "@nju/data-access-portal-wwt";
import { SideBox } from "@nju/ui";
import { formatPrice } from "@nju/utils";
import { HeadingFtth, SidebarFtthOfferBenefits } from "./partials";

interface ISidebarFtthOfferProps {
  offer: IFtthOffer;
  orchestrator: IFtthOrchestrator | undefined;
  isReactivationProcess: boolean;
}

export function SidebarFtthOffer({
  offer,
  orchestrator,
  isReactivationProcess,
}: ISidebarFtthOfferProps) {
  const installationToken = sessionStorage.getItem("installationToken");
  const decodedToken = useDecodedToken(installationToken);

  if (!orchestrator) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  const isSfh =
    decodedToken?.address.isSfh || orchestrator.installationAddress?.isSfh;

  return (
    <SideBox
      isExpandable={true}
      isExpanded={false}
      testId="offer-box"
      title="oferta"
    >
      {({ isExpanded }) => {
        return isExpanded ? (
          <>
            <HeadingFtth isSfh={isSfh} offer={offer} />
            <SidebarFtthOfferBenefits
              benefits={offer.shortFeatures}
              bundleDiscount={offer.ftthBundleDiscount || offer.bundleDiscount}
              installationPrice={formatPrice(offer.totalOneTimePrice)}
              isReactivationProcess={isReactivationProcess}
            />
          </>
        ) : (
          <div className="only-mobile:hidden">
            <HeadingFtth isSfh={isSfh} offer={offer} />
          </div>
        );
      }}
    </SideBox>
  );
}
